import { PAGAMO_RED, PAGAMO_BLUE } from 'constants/colors'

const primary = {
  fill: PAGAMO_RED,
}

const secondary = {
  fill: PAGAMO_BLUE,
}

function PaGamOLogo() {
  return (
    <svg viewBox="0 0 333.952 74.267" x="0px" y="0px">
      <g>
        <path
          style={primary}
          d="M92.598,47.23c-0.051-12.034-9.82-21.774-21.866-21.774c-12.077,0-21.868,9.791-21.868,21.868 s9.791,21.868,21.868,21.868c0,0,0.003,0,0.005,0v0H92.6V47.23H92.598z M70.732,56.279c-5.069,0-9.178-4.109-9.178-9.178 s4.109-9.178,9.178-9.178c5.069,0,9.178,4.109,9.178,9.178S75.801,56.279,70.732,56.279z"
        />
        <path
          style={primary}
          d="M261.559,42.23c-0.045-9.272-8.136-16.775-18.111-16.775c-3.998,0-7.691,1.208-10.688,3.249 c-2.996-2.041-6.69-3.249-10.688-3.249c-9.976,0-18.066,7.503-18.111,16.775h-0.002v26.961h14.87V42.308h0.001 c0.006-1.873,1.453-3.39,3.239-3.39c1.785,0,3.233,1.517,3.239,3.39h0.026v26.883h14.87V42.308h0.004 c0.006-1.873,1.453-3.39,3.239-3.39c1.785,0,3.233,1.517,3.239,3.39h0.023v26.883h14.87V42.23H261.559z"
        />
        <path
          style={primary}
          d="M200.063,47.23c-0.051-12.034-9.82-21.774-21.866-21.774c-12.077,0-21.868,9.791-21.868,21.868 s9.791,21.868,21.868,21.868c0.002,0,0.003,0,0.005,0v0h21.863V47.23H200.063z M178.198,56.279c-5.069,0-9.178-4.109-9.178-9.178 s4.109-9.178,9.178-9.178c5.069,0,9.178,4.109,9.178,9.178S183.266,56.279,178.198,56.279z"
        />
        <g>
          <path
            style={primary}
            d="M24.628,2.441C11.026,2.441,0,13.467,0,27.069v42.122h16.974c0,0-0.127-38.709-0.029-41.617 c0.153-4.536,3.653-8.443,8.15-8.173c3.284,0.197,5.993,2.467,6.886,5.512h0.01c0.005,0.02,0.006,0.04,0.011,0.06 c0.123,0.433,0.204,0.881,0.249,1.341c0.28,1.481,0.478,2.99,0.478,4.552c0,8.674-4.401,16.31-11.082,20.83h2.98 c13.601,0,24.627-11.026,24.627-24.627v0C49.255,13.467,38.229,2.441,24.628,2.441z"
          />
          <path
            style={secondary}
            d="M19.12,34.751v16.018c6.651-3.868,11.199-10.948,11.477-19.114 c-1.522,1.872-3.887,3.096-6.469,3.096H19.12z"
          />
        </g>
        <g>
          <polygon
            style={secondary}
            points="126.7,32.621 126.7,47.389 136.103,47.389 151.493,32.621"
          />
          <path
            style={primary}
            d="M125.772,53.61c-9.058,0-16.401-7.967-16.401-17.794c0-9.827,7.343-17.794,16.401-17.794 c2.518,0,4.893,0.634,7.025,1.733l10.349-11.473c-4.945-3.68-10.925-5.841-17.374-5.841c-16.99,0-30.763,14.942-30.763,33.375 c0,18.433,13.773,33.375,30.763,33.375c22.913,0,27.279-15.799,27.014-34.946c0,0-13.696,13.828-15.067,14.655 c-0.522,0.41-1.044,0.805-1.561,1.181C131.879,53.189,127.348,53.61,125.772,53.61z"
          />
        </g>
        <g>
          <path
            style={secondary}
            d="M326.312,25.902c-4.218,0-7.638,3.42-7.639,7.639l0.002,11.836l8.369-4.832 c2.796-1.614,5.102-3.748,6.908-6.193l0-0.811C333.953,29.319,330.53,25.902,326.312,25.902z"
          />
          <g>
            <path
              style={secondary}
              d="M293.577,11.9l6.428,3.711l0.023-0.013l12.431,7.178c3.654,2.109,8.326,0.857,10.435-2.796 c2.109-3.654,0.86-8.327-2.796-10.435l-13.482-7.784c-4.063-2.348-9.109-2.349-13.173-0.003L281.67,8.556 C285.725,8.649,289.816,9.728,293.577,11.9z"
            />
            <path
              style={primary}
              d="M333.952,49.114l-0.001-11.311c-1.657,1.782-3.6,3.352-5.817,4.632l-9.46,5.462l-5.546,3.202 l-12.065,6.966c-0.642,0.37-1.432,0.37-2.074,0l-16.573-9.57c-0.642-0.37-1.037-1.055-1.037-1.796l0-19.137 c0-0.741,0.395-1.426,1.037-1.796l15.406-8.895l-5.337-3.081c-4.773-2.755-10.133-3.564-15.185-2.711l-4.614,2.664 c-4.075,2.353-6.585,6.7-6.584,11.405l0.001,23.962c-0.001,2.347,0.628,4.614,1.768,6.587c1.141,1.971,2.787,3.65,4.817,4.822 l20.755,11.983c4.074,2.352,9.094,2.352,13.168,0l20.756-11.984C331.443,58.166,333.953,53.819,333.952,49.114z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default PaGamOLogo
